import { useApolloClient } from "@apollo/client";
import useNotifier from "@saleor/hooks/useNotifier";
import React, { useContext } from "react";
import { useIntl } from "react-intl";

import { UserContext } from "./";
import { useAuthProvider } from "./hooks/useAuthProvider";
import { getTokens } from "./utils";

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const apolloClient = useApolloClient();
  const intl = useIntl();
  const notify = useNotifier();

  const authProvider = useAuthProvider({ intl, notify, apolloClient });

  return (
    <UserContext.Provider value={authProvider}>{children}</UserContext.Provider>
  );
};
export const useAuth = () => {
  const user = useContext(UserContext);
  const isAuthenticated = !!user.user && !!getTokens().auth;
  const authInProgress = !!getTokens().auth && !user.user;
  return {
    hasToken: !!getTokens().auth,
    tokenFake: getTokens().auth === "FAKE_TOKEN",
    isAuthenticated,
    authInProgress,
    user: user.user,
    zone: user.zone,
    setZone: user.setZone
  };
};
export default AuthProvider;
